/* eslint-disable @typescript-eslint/no-explicit-any */

export default function CTL_Modal({children,onClose}:any){

  return <>
  <div className="
      fixed top-0 left-0
      bg-black/40
      w-full h-full z-50
      backdrop-blur-xs
      flex flex-col items-center justify-center-safe
    " 
    onClick={(e)=>{
      e.stopPropagation()
      if( onClose ) onClose();
    }}
  >
    {children}
  </div>
  </>
}